/**
 * A fiduciary's Taxpayer Identification Number.
 *
 * An executor need not be a person. A bank's trust department, a law firm or a
 * trust company can be appointed, and the court forms ask such an executor for
 * a TIN where they ask a human for an SSN. It is written NN-NNNNNNN, the same
 * shape as the estate's own EIN, because it is the same kind of number.
 */
export const formatTIN = (value?: string | null): string => {
  if (!value) return '';

  // A masked value read back from the API is nine characters of nothing and
  // four real digits. Reformatting it as a number would send the mask back as
  // if it were one.
  if (value.startsWith('**-***')) {
    return `**-***${value.slice(6).replace(/\D/g, '').slice(0, 4)}`;
  }

  const digits = value.replace(/\D/g, '').slice(0, 9);

  return digits.length > 2 ? `${digits.slice(0, 2)}-${digits.slice(2)}` : digits;
};

/**
 * Validation for the TIN field. The masked form passes too: a form read back
 * from the API shows it, and leaving it untouched must not be an error.
 */
export const TIN_RULE = {
  pattern: /^(?:\d{2}-\d{7}|\*{2}-\*{3}\d{4})$/,
  message: 'A TIN is nine digits, written as 12-3456789',
};
